import { AttendanceFeatures } from './AttendanceFeatures';
export class DeskControllerBase {
    static $inject = ['application', 'LoadingService', 'DeskConfigurationService', '$scope'];
    constructor(application, LoadingService, DeskConfigurationService, $scope) {
        'ngInject';
        this.application = application;
        this.LoadingService = LoadingService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.$scope = $scope;
        this.isCheckingTools = true;
        this.showUnavailableToolWarning = false;
        this.$scope = $scope;
        this.$scope.forms = {};
        this.$DeskOnInit();
    }
    async $DeskOnInit() {
        if (await this.shouldBlockTools()) {
            return;
        }
    }
    async shouldBlockTools() {
        this.isCheckingTools = true;
        await this.checkFeatures();
        let shouldBlockTools = false;
        if (this.isDeskSalesforceIntegrationEnabled) {
            this.LoadingService.startLoading();
            shouldBlockTools = await this.DeskConfigurationService.shouldBlockTools(this.application, this.isConfigurationsApplicationsDomainUsageEnabledBaseGet);
            this.LoadingService.stopLoading();
        }
        else {
            shouldBlockTools = false;
        }
        this.isCheckingTools = false;
        this.showUnavailableToolWarning = shouldBlockTools;
        return this.showUnavailableToolWarning;
    }
    async checkFeatures() {
        this.isDeskSalesforceIntegrationEnabled = await AttendanceFeatures.isDeskSalesforceIntegrationEnabled();
        this.isConfigurationsApplicationsDomainUsageEnabledBaseGet = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
    }
}
DeskControllerBase.$inject = ['application', 'LoadingService', 'DeskConfigurationService', '$scope'];
